// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import {
  discardReplacementCart,
  useReplacementCart,
} from '@iheartjane/cart/utils';
import { Box } from '@iheartjane/reefer';
import { useNavigate } from 'react-router';

import { useCartActions } from '@jane/monolith/components/cart/cartFacade/useCartActions';
import { Modal } from '@jane/monolith/components/modal';
import { useCustomerDispatch } from '@jane/monolith/customer/redux';
import { closeModal } from '@jane/monolith/customer/redux/modal';
import { useMoengage } from '@jane/shared-ecomm/tracking';
import { useEcommApp } from '@jane/shared/providers';
import { monolithPaths as paths } from '@jane/shared/util';

import { ReplaceCartContents } from './contents';

export const ReplaceCart = () => {
  const { moeTrack } = useMoengage();
  const theme = useTheme();
  const dispatch = useCustomerDispatch();
  const navigate = useNavigate();
  const { appMode } = useEcommApp();
  const { replaceCart } = useCartActions();
  const replacementCart = useReplacementCart();

  const leave = () => {
    discardReplacementCart();

    if (appMode === 'default') {
      return dispatch(closeModal());
    }

    return navigate(paths.embeddedMenu());
  };

  const onReplaceCart = () => {
    if (replacementCart) replaceCart(replacementCart, moeTrack);
    leave();
  };

  if (appMode === 'default') {
    return (
      <div>
        <Modal
          closeModal={leave}
          contentLabel="Clear bag"
          // eslint-disable-next-line react/forbid-component-props -- legacy emotion
          css={{ borderRadius: theme?.borderRadius.sm }}
          width="small"
        >
          {(close: () => void) => (
            <ReplaceCartContents
              onCancel={close}
              onReplaceCart={onReplaceCart}
            />
          )}
        </Modal>
      </div>
    );
  }

  return (
    <Box mx="auto" maxWidth={360} pt={24}>
      <ReplaceCartContents onCancel={leave} onReplaceCart={onReplaceCart} />
    </Box>
  );
};
